'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/querystring-es3/index.js
// module id = ../../node_modules/querystring-es3/index.js
// module chunks = 1